export default __webpack_public_path__ + "static/media/release.799ae1d8.gif";